module.exports = __webpack_public_path__ + "img/login_page_logo.1e534cd6.png";